var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMegaphoneIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21 20.1H20.05V19.4568V10.6H18.15V18.6959L10.551 15.6568V9.34315L18.15 6.3041V8.7H20.05V5.5441V4.9H21V20.1ZM7.39315 20.1L6.25315 17.25H7.7V20.1H7.39315ZM3.9 10.6C3.9 10.0765 4.3256 9.65 4.85 9.65H8.65V10.6H4.85V12.5H8.65V15.35H4.85C4.3256 15.35 3.9 14.9234 3.9 14.4V10.6ZM18.15 4.25685L9.4176 7.75H4.85C3.2787 7.75 2 9.0287 2 10.6V14.4C2 15.7366 2.92815 16.8529 4.1698 17.1588L6.10685 22H9.6V17.3231L18.15 20.7431V21.05V22H22.9V3H18.15V4.25685Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMegaphoneIcon);
export default __webpack_public_path__ + "static/media/MegaphoneIcon.57dff7d84b99848b3bbfb0f5366705ab.svg";
export { ForwardRef as ReactComponent };